import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { Icons } from '@/components/atoms/Icons/Icons'

import { RegionsMilestonesFormProvider, type RegionsMilestonesFormProviderProps } from './RegionsMilestonesFormProvider'
import { RegionsMilestonesFormTable, type RegionsMilestonesFormTableProps } from './RegionsMilestonesFormTable'

export interface RegionsMilestonesFormProps
  extends RegionsMilestonesFormProviderProps, RegionsMilestonesFormTableProps {
  currentOperatingDate?: string
}

export const RegionsMilestonesForm: FC<RegionsMilestonesFormProps> = ({
  promotions,
  currentOperatingDate,
  ...props
}) => {
  const intl = useIntl()

  return (
    <RegionsMilestonesFormProvider {...props}>
      <div className="flex flex-col gap-4 border border-gray-200 p-4">
        <div className="flex items-center gap-2">
          <Icons.promotionMilestone className="size-5" fill="#0E9F6E" />
          <h3 className="text-lg font-semibold text-gray-900 uppercase">
            {intl.formatMessage({ id: 'regionMilestones.title' })}
          </h3>
        </div>

        <RegionsMilestonesFormTable promotions={promotions} currentOperatingDate={currentOperatingDate} />
      </div>
    </RegionsMilestonesFormProvider>
  )
}
